import React from "react"

import { over1400 } from "~css/breakpoints.module.scss"
import * as style from "./Control.module.scss"

const ActiveEndpoint = ({ explorer }) => (
  <>
    <span
      className={[style.verb, over1400].join(" ")}
      data-verb={explorer.endpoint.verb}
    >
      {explorer.endpoint.verb}
    </span>
    <div className={[style.title, over1400].join(" ")}>
      {explorer.endpoint.title}
    </div>
  </>
)

export default ActiveEndpoint
